// Tiny Slider
import { tns } from "tiny-slider/src/tiny-slider";

document.addEventListener("DOMContentLoaded", function() {
  // Normal carousel, cards in a line
  if(document.getElementsByClassName('.tns-carousel')) {
    const tnsCarousel = document.querySelectorAll('.tns-carousel');
    tnsCarousel.forEach(slider => {
      var slider = tns({
        container: slider,
        items: 3,
        slideBy: 'page',
        autoplay: false,
        nav: false, 
        controlsPosition: 'bottom'
      });
    });
  }

  // Single image carousel
  if(document.getElementsByClassName('.tns-carousel-single')) {
    const tnsCarouselSingle = document.querySelectorAll('.tns-carousel-single');
    tnsCarouselSingle.forEach(slider => {
      var slider = tns({
        container: slider,
        items: 1,
        slideBy: 'page',
        autoplay: false,
        nav: true, 
        navPosition: 'bottom',
        controls: false,
        mouseDrag: true
      });
    });
  }
  
  // Single and teaser on mobile, nothing on desktop
  if(document.getElementsByClassName('.tns-carousel-mobile-tease')) {
    const tnsCarousel = document.querySelectorAll('.tns-carousel-mobile-tease');
    tnsCarousel.forEach(slider => {
      var slider = tns({
        container: slider,
        items: 1.25,
        slideBy: 'page',
        autoplay: false,
        nav: false, 
        controls: false,
        gutter: 15,
        mouseDrag: true,
        responsive: {
          900: {
            items: 3,
            speed: 500,
            slideBy: 1,            
            controls: true,
            autoWidth: false
          }
        }
      });
    });
  }

  // Single fader
  if(document.getElementsByClassName('.tns-carousel-single-fade')) {
    const tnsCarouselSingle = document.querySelectorAll('.tns-carousel-single-fade');
    tnsCarouselSingle.forEach(slider => {
      var slider = tns({
        container: slider,
        mode: 'gallery',
        autoplay: true,
        nav: false, 
        controls: false,
        animateIn: 'fadeInDown',
        animateOut: 'fadeOutDown',
        autoplayButtonOutput: false,
        speed: 2000
      });
    });
  }

  // Full width cards
  if(document.getElementsByClassName('.tns-carousel-full-width')) {
    const tnsCarouselSingle = document.querySelectorAll('.tns-carousel-full-width');
    tnsCarouselSingle.forEach(slider => {
      var slider = tns({
        container: slider,
        items: 2,
        slideBy: 1,
        //fixedWidth: 226,
        //center: true,
        loop: true,
        autoplay: true,
        //swipeAngle: true,
        speed: 400,
        autoplayTimeout: 1500,
        autoplayButtonOutput: false,
        mouseDrag: true,
        nav: false, 
        controls: false,
        responsive: {
          900: {
            items: 5,
          }
        }
      });
    });
  }
});